<template>
  <div class="gray-bg">
    <div class="wrapper wrapper-content" style="height: 100vh; padding-top: 40vh">
      <div class="text-center">
        <div style="margin: auto auto;">
        <h1>Loading report...</h1>
        <div class="fa-10x text-center">
          <i class="fas fa-cog slow-spin cog-spinner"></i>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cog-spinner {
  color: #c0c0c0;
}
.slow-spin {
  -webkit-animation: fa-spin 3s infinite linear;
  animation: fa-spin 3s infinite linear;
}
</style>

<script>
import _ from 'lodash'

export default {
  name: "ReportLoader",
  mounted() {
    if(this.$route.meta.report) {
      // Adjust the URL
      var reportURL = this.$route.meta.report.url

      if(_.isArray(this.$route.meta.report.variables)) {
        this.$route.meta.report.variables.forEach(routeVar => {
          reportURL = reportURL.replace(new RegExp(':'+routeVar, "g"), this.$route.params[routeVar]);
        })
      }

      // Append options
      if(this.$route.meta.report.options != null) {
        var queryParams = {}
        this.$route.meta.report.options.forEach(option => {
          queryParams[option] = this.$route.query[option]
        })

        reportURL += '?' + $.param(queryParams)
      }

      // Request a signed URL so we can display the PDF without auth headers
      this.$apiService.reportingService.generateReportSignedURL(reportURL)
      .then(response => {
        window.location.href = response.data.url
      })
    }
  },
  methods: {
    
  },
  computed: {
    
  }
}
</script>
